module.exports = __webpack_public_path__ + "img/smile4.9d00dc27.png";